module.exports = __webpack_public_path__ + "static/media/208.a0965c2c.jpg";